import pino from 'pino';

export type Logger = pino.Logger;

const logger: Logger = pino({
  timestamp: true,
  level: 'info',
});

export default logger;
